export default [
    {
      path: "acciones-movimientos/exoneracion-marcacion",
      name: "exoneracion-marcacion",
      component: () =>
        import( /* webpackChunkName: "despido_personal" */ "../views/ExoneracionMarcacion.vue" ),
    },
    {
      path: "acciones-movimientos/exoneracion-marcacion/crear",
      name: "crear-exoneracion-marcacion",
      component: () =>
        import("../views/GestionExoneracionMarcacion.vue" ),
    },
    {
      path: "acciones-movimientos/exoneracion-marcacion/historial-detalle/:id",
      name: "detalle-exoneracion-marcacion",
      component: () =>
        import("../views/HistorialExonerado.vue" ),
    },
    {
      path: "acciones-movimientos/exoneracion-marcacion/detalle-exonerado/:id",
      name: "detalle-exonerado",
      component: () =>
        import("../views/GestionExoneracionMarcacion.vue" ),
    },
    {
      path: "acciones-movimientos/exoneracion-marcacion/detalle-exonerado/seguimiento/:id",
      name: "detalle-exonerado-seguimiento",
      component: () =>
        import("../views/GestionExoneracionMarcacion.vue" ),
    },
        {
      path: "acciones-movimientos/exoneracion-marcacion/detalle-exoneracion-observada/:id",
      name: "detalle-exoneracion-observada",
      component: () =>
        import("../views/GestionExoneracionMarcacion.vue" ),
    }
]